import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Token storage uses localStorage by design — the alternative (httpOnly cookies)
  // requires same-origin or cross-site cookie config that conflicts with our
  // preview/production split through the Kubernetes ingress. JWTs are short-lived
  // and the React XSS surface is minimised by React's auto-escaping.
  const token = localStorage.getItem("kippu_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Multi-tenant: scope every request to the currently-active client. The BE
  // uses this header to enforce data isolation between Starlink / Ooredoo / Al-Meera.
  const clientId = localStorage.getItem("kippu_client_id");
  if (clientId) {
    config.headers["X-Client-Id"] = clientId;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("kippu_token");
      localStorage.removeItem("kippu_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
